module.exports = __webpack_public_path__ + "static/media/07.935e57b5.png";